import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";

// Simple URL-based routing for auth pages
const getRouteComponent = () => {
  const path = window.location.pathname;
  
  if (path === '/reset-password') {
    return <ResetPasswordPage />;
  }
  
  if (path === '/verify-email') {
    return <VerifyEmailPage />;
  }
  
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {getRouteComponent()}
  </React.StrictMode>,
);
